import { useEffect, useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";
import allRoutes from "../../routes";

const APP_NAME = ""; // optional such as "Public Gateway"

// Flattens nested routes into a list with full paths + titles
function flattenRoutes(
  routes: any[],
  base = ""
): Array<{ path: string; title?: string }> {
  const out: Array<{ path: string; title?: string }> = [];
  for (const r of routes) {
    const full = r.path
      ? base.endsWith("/") || r.path.startsWith("/")
        ? `${base}${r.path}`
        : `${base}/${r.path}`
      : base || "/";
    if (r.title) out.push({ path: full, title: r.title });
    if (r.children) out.push(...flattenRoutes(r.children, full));
  }
  return out;
}

export default function RouteTitle() {
  const location = useLocation();
  const flat = useMemo(() => flattenRoutes(allRoutes), [allRoutes]);

  useEffect(() => {
    const match = flat.find((r) =>
      matchPath({ path: r.path, end: true }, location.pathname)
    );
    const pageTitle = match?.title || "Home";
    const suffix = APP_NAME ? ` — ${APP_NAME}` : "";
    document.title = `${pageTitle}${suffix}`;
  }, [location.pathname, flat]);

  return null; // it renders nothing
}
